var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParticipantVideoOffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64137 8.75715C12.1393 8.53408 14.653 8.55355 17.1471 8.81528L17.7924 8.88299C19.0238 9.01222 20.015 9.94516 20.2212 11.1594L23.7018 9.31249C23.9376 9.18732 24.2206 9.18861 24.4553 9.31592C24.6901 9.44323 24.8452 9.6796 24.8686 9.94535L24.895 10.2463C25.1911 13.6201 25.1911 17.0133 24.895 20.3871L24.8686 20.6881C24.8452 20.9538 24.6901 21.1902 24.4553 21.3175C24.2206 21.4448 23.9376 21.4461 23.7018 21.3209L20.2212 19.474C20.015 20.6883 19.0238 21.6212 17.7924 21.7504L17.1472 21.8181C14.653 22.0799 12.1393 22.0994 9.64137 21.8763L7.96201 21.7263C6.69658 21.6133 5.67415 20.6478 5.49036 19.3922C5.09475 16.6896 5.09475 13.9439 5.49036 11.2412C5.67415 9.98566 6.69658 9.02012 7.96201 8.90712L9.64137 8.75715ZM20.4176 17.8262C20.5027 17.8396 20.5872 17.8671 20.6676 17.9098L23.3802 19.3492C23.5727 16.6643 23.5727 13.9691 23.3802 11.2842L20.6676 12.7236C20.5872 12.7663 20.5027 12.7938 20.4176 12.8072C20.5664 14.4769 20.5664 16.1565 20.4176 17.8262Z",
    stroke: "#E90000",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.4362,
    y: 3.0991,
    width: 0.895801,
    height: 28.2083,
    transform: "rotate(32.7976 21.4362 3.0991)",
    fill: "white",
    fillOpacity: 0.63,
    stroke: "#E90000",
    strokeWidth: 0.895801
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipantVideoOffIcon);
export default __webpack_public_path__ + "static/media/participantVideoOffIcon.a47f579a7d418205b89612e2e681fd06.svg";
export { ForwardRef as ReactComponent };